/**
 * API & Socket configuration — production uses relative paths (port 443 only) for government networks.
 *
 * Development (CRA): use relative `/api` so webpack-dev-server proxies via `src/setupProxy.js` to
 * `REACT_APP_API_PROXY_TARGET` (default http://127.0.0.1:5000). Same-origin works for LAN IP:3000.
 *
 * Optional overrides: REACT_APP_API_URL (or REACT_APP_API_BASE_URL), REACT_APP_SOCKET_URL (no trailing slash).
 * Dev proxy target for /video.mp4 (setupProxy.js): REACT_APP_API_PROXY_TARGET (default http://127.0.0.1:5000).
 */
const trimEndSlash = (s: string): string => s.trim().replace(/\/+$/, '');

const envApi = trimEndSlash(
  process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || ''
);
const envSocket = trimEndSlash(process.env.REACT_APP_SOCKET_URL || '');

const PRODUCTION_ORIGIN = 'https://openauction24.com';

/** Default `/api` (CRA proxy in dev, same-origin in prod). Override with REACT_APP_API_URL. */
export const API_BASE_URL = envApi.length > 0 ? envApi : '/api';

/**
 * Absolute API path for axios calls. Use this instead of `axios.defaults.baseURL` + `${API_BASE_URL}/...`
 * (that combination becomes `/api/api/...`).
 */
export function apiUrl(path: string): string {
  const base = trimEndSlash(API_BASE_URL);
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}

const devBackendPort = process.env.REACT_APP_DEV_API_PORT || '5000';

/** Dev: actual tab origin (localhost or LAN). Prod: canonical site. */
export const SITE_ORIGIN =
  process.env.NODE_ENV === 'development' && typeof globalThis.window !== 'undefined'
    ? globalThis.window.location.origin
    : PRODUCTION_ORIGIN;

/** Socket.io origin: in dev, same host as the page + REACT_APP_DEV_API_PORT (default 5000). */
export const SOCKET_URL =
  envSocket.length > 0
    ? envSocket
    : process.env.NODE_ENV === 'development'
      ? typeof globalThis.window !== 'undefined'
        ? `${globalThis.window.location.protocol}//${globalThis.window.location.hostname}:${devBackendPort}`
        : `http://localhost:${devBackendPort}`
      : typeof globalThis.window !== 'undefined'
        ? globalThis.window.location.origin
        : '';

/** Ensure API is always HTTPS in production (for any absolute URL fallback). */
export const getProductionApiBase = (): string =>
  typeof globalThis.window !== 'undefined' && globalThis.window.location.protocol === 'https:'
    ? `${globalThis.window.location.origin}/api`
    : `${PRODUCTION_ORIGIN}/api`;

export default API_BASE_URL;
